const routes = {
  listing: `/l/:listingId`,
  seoListing: `/listing/:addressSlug/:listingId`,
  agentProfile: `/u/:agentSlug`,
  marketStats: '/marketstats',
  map: `/m`,
  agentSignup: `/signup/:signupCode?`,
  signinConfirmEmail: '/auth/confirm-email',
  signinConfirmAgent: '/auth/confirm-agent',
  watchedSearch: '/watched-searches/:id',
  watchedSearchDelete: '/watched-searches/:id/delete',
  watchedListingDeleteByUserId:
    '/users/:userId/watched/listings/:listingId/delete',
};

export default routes;
